export default __webpack_public_path__ + "static/media/huaweiZ2.caabfda3.jpg";